import type { Contract } from "~/composables/shop/subscriptionTypes";
export const isCancelled = (contract: Contract) => {
  return contract?.status.includes("cancel");
};


